module.exports = __webpack_public_path__ + "img/Ladies_White.1481f242.png";